import React from 'react';
import PropTypes from 'prop-types';
import PreferredStore from './_preferred-store/component';

const DynamicComponent = (props) => {
  // Component to be used by the 'dummy component' that has the componment type "dynamicComponent" in the CMS
  const { componentName } = props;

  const transMap = {
    preferred_store: PreferredStore,
    default: PreferredStore,
  };
  const ComponentVariant = transMap[componentName] || transMap.default;

  return (
    <div>
      <ComponentVariant {...props} />
    </div>
  );
};

DynamicComponent.propTypes = {
  componentName: PropTypes.string,
};

export default DynamicComponent;
